import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import classes from './../simulator-v2.module.scss';
import { CcfUpArrowIcon } from '@nice-ccf/ui-controls';

/**
 * To show the dropdown element which takes the below props
 * @param props - it will have currentValue, field, label for the dropdown, dropdown options and a onchange handler
 * @example
 * @returns
 */
export function DropDown(props: {
  customerHistoryId?: any;
  isFromContactHistory?: boolean;
  isFromInteractionHistory?: boolean;
  currentValue: string;
  field: string;
  label: string;
  options: string[];
  handleInputChange?: (field: string, value: string) => any;
  handleInputChangeForHistory?: (
    id: any,
    field: string,
    value: string,
    isFromContactHistory?: boolean
  ) => void;
  handleInputChangeForInteractionHistory?: (
    id: any,
    field: string,
    value: string
  ) => void;
  id?: any;
  stackName?: any;
  selectInputStyle?: any;
  selectRootStyle?: any;
}) {
  let { currentValue } = props;
  const {
    customerHistoryId,
    isFromContactHistory,
    isFromInteractionHistory,
    handleInputChangeForInteractionHistory,
    field,
    label,
    options,
    handleInputChange,
    handleInputChangeForHistory,
    id,
    stackName,
    selectInputStyle,
    selectRootStyle,
  } = props;
  if (!currentValue) currentValue = options[0];

  return (
    <FormControl
      variant="outlined"
      size={
        isFromContactHistory || isFromInteractionHistory ? 'small' : undefined
      }
      style={{
        width:
          isFromContactHistory || isFromInteractionHistory ? '100%' : undefined,
        marginBottom:
          isFromContactHistory || isFromInteractionHistory ? '15px' : undefined,
      }}
      id={`${id}` || 'demo-simple-select'}
    >
      <InputLabel id="demo-simple-select-outlined-label">{label}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        variant="outlined"
        sx={{
          '&.MuiOutlinedInput-root': selectInputStyle,
          '& .MuiSelect-root': selectRootStyle,
          '&& fieldset': {
            border: '1px solid #c4c4c4',
          },
        }}
        IconComponent={() => (
          <CcfUpArrowIcon className={classes.arrowIconForDropdown} />
        )}
        value={currentValue}
        onChange={(event: any) => {
          isFromContactHistory
            ? handleInputChangeForHistory?.(
                customerHistoryId,
                field,
                event.target.value as string,
                isFromContactHistory
              )
            : isFromInteractionHistory
            ? handleInputChangeForInteractionHistory?.(
                customerHistoryId,
                field,
                event.target.value as string
              )
            : handleInputChange?.(field, event.target.value as string);
        }}
        style={{ marginBottom: '1rem' }}
        label={label}
      >
        {options.map((option: string, index: number) => {
          return (
            <MenuItem
              value={option}
              key={index}
              id={`sm_${stackName}_${option}`}
            >
              {option}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

/**
 *
 * @param state -
 * @param action -
 * @example
 * @returns
 */
export const processResultToArray = (
  inputArray: Array<any>,
  media: string,
  agentName: string
) => {
  const formattedArray: Array<any> = [];
  inputArray.forEach((item) => {
    let messageFrom, startTimestamp, endTimestamp, message;

    if (media === 'Voice') {
      [messageFrom, startTimestamp, endTimestamp, message] = item.split('~');
      startTimestamp = parseInt(startTimestamp);
      endTimestamp = parseInt(endTimestamp);
    } else if (media === 'Digital') {
      [messageFrom, message] = item.split('~');
    }
    const formattedItem = {
      messageFrom: messageFrom.toLowerCase(),
      // intermediateMsg: message,
      // postiveMsg: message,
      // negativeMsg: message,
      message: [message],
      agentName,
      card: '',
      startTime: startTimestamp,
      endTime: endTimestamp,
    };
    formattedArray.push(formattedItem);
  });

  return formattedArray;
};

/**
 *
 * @param state -
 * @param action -
 * @example
 * @returns
 */
export const generateRandomId = (name1?: string, name2?: string) => {
  const currentDate = new Date();
  const dd = String(currentDate.getDate()).padStart(2, '0');
  const mm = String(currentDate.getMonth() + 1).padStart(2, '0');
  const hh = String(currentDate.getHours()).padStart(2, '0');
  const MM = String(currentDate.getMinutes()).padStart(2, '0');
  const generatedNumber = parseInt(dd + mm + hh + MM);
  return generatedNumber;
};

/**@example */
export const generateDate = () => {
  const today = new Date().toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  }); // format: Sep 20, 2024 9:30:20 PM
  return today;
};

export const awsS3Config = {
  accessKeyId: 'AKIAVFMUJ6SX7NP6G5FY',
  secretAccessKey: '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',
  s3Bucket:
    window.location.hostname === 'd1u959wi0vug3n.cloudfront.net'
      ? 'cxone-agent-html-demo-phase2'
      : 'cxone-agent-demo-app',
  region: 'us-west-2',
};
